import React from "react"
import {
  Avatar,
  Box,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@mui/material"

import { useSelector } from "react-redux"
import { Link } from "react-router-dom"

const RightBar = () => {
  const { posts, isLoading } = useSelector((state) => state.posts)
  if (isLoading) return "Loading..."
  const sortPostsByViewsCount =
    posts &&
    Array.from(posts)
      .slice(0, 3)
      .sort(({ viewsCount: a }, { viewsCount: b }) => b - a)

  return (
    <Box>
      <Typography bgcolor="black" align="center" color="white">
        Most Popular
      </Typography>
      <List
        sx={{
          width: "100%",
          height: "100%",
          bgcolor: "background.paper",
        }}
      >
        {sortPostsByViewsCount &&
          sortPostsByViewsCount.map((post) => (
            <ListItem
              alignItems="flex-start"
              key={post._id}
              component={Link}
              to={`/posts/${post._id}`}
            >
              <ListItemAvatar>
                <Avatar
                  sx={{ width: 80, height: 80, marginRight: 2 }}
                  variant="square"
                  alt="Remy Sharp"
                  src={`${process.env.REACT_APP_URL}${post.selectedFile}`}
                />
              </ListItemAvatar>
              <ListItemText sx={{ marginRight: 2 }} secondary={post.title} />
            </ListItem>
          ))}
        {/* <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar
              sx={{ width: 80, height: 80, marginRight: 2 }}
              variant="square"
              alt="Remy Sharp"
              src={bus1}
            />
          </ListItemAvatar>
          <ListItemText
            sx={{ marginRight: 2 }}
            secondary={" — I'll be in your neighborhood doing errands this…"}
          />
        </ListItem> */}
        {/* <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar
              sx={{ width: 80, height: 80, marginRight: 2 }}
              variant="square"
              alt="Remy Sharp"
              src={bus2}
            />
          </ListItemAvatar>
          <ListItemText
            secondary={" — I'll be in your neighborhood doing errands this…"}
          />
        </ListItem>
        <ListItem alignItems="flex-start">
          <ListItemAvatar>
            <Avatar
              sx={{ width: 80, height: 80, marginRight: 2 }}
              variant="square"
              alt="Remy Sharp"
              src={bus3}
            />
          </ListItemAvatar>
          <ListItemText
            secondary={" — I'll be in your neighborhood doing errands this…"}
          />
        </ListItem> */}
      </List>
    </Box>
  )
}
export default RightBar
